import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Combobox } from '../../ui/combobox';

const YES_NO_OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

const YesNoField = ({ label, value, onChange }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <div className="mt-1">
      <Combobox options={YES_NO_OPTIONS} value={value} onValueChange={onChange} placeholder="Select..." className="h-9 text-xs" />
    </div>
  </div>
);

const PrepressTab = ({ orderData, setOrderData, onFileUpload }) => {
  const set = (key, val) => setOrderData({ ...orderData, [key]: val });

  return (
    <div className="space-y-3 pt-3">
      <div className="grid grid-cols-5 gap-3">
        <YesNoField label="PCB" value={orderData.pcb} onChange={(v) => set('pcb', v)} />
        <YesNoField label="Veg Logo" value={orderData.veg_logo} onChange={(v) => set('veg_logo', v)} />
        <YesNoField label="White" value={orderData.white} onChange={(v) => set('white', v)} />
        <YesNoField label="Overcoat" value={orderData.overcoat} onChange={(v) => set('overcoat', v)} />
        <YesNoField label="Mattcoat" value={orderData.mattcoat} onChange={(v) => set('mattcoat', v)} />
      </div>
      <div className="grid grid-cols-5 gap-3">
        <YesNoField label="Barcode Genuine" value={orderData.barcode_genuine} onChange={(v) => set('barcode_genuine', v)} />
        <YesNoField label="Barcode Fake" value={orderData.barcode_fake} onChange={(v) => set('barcode_fake', v)} />
        <YesNoField label="Repeat Trap" value={orderData.repeat_trap} onChange={(v) => set('repeat_trap', v)} />
        <YesNoField label="Reg Marks" value={orderData.registration_marks} onChange={(v) => set('registration_marks', v)} />
        <YesNoField label="Slitting" value={orderData.slitting} onChange={(v) => set('slitting', v)} />
      </div>
      <div className="grid grid-cols-5 gap-3">
        <YesNoField label="ARC Marks" value={orderData.arc_marks} onChange={(v) => set('arc_marks', v)} />
        <YesNoField label="Gray Scale Circles" value={orderData.gray_scale_circles} onChange={(v) => set('gray_scale_circles', v)} />
        <YesNoField label="TT Line" value={orderData.tt_line} onChange={(v) => set('tt_line', v)} />
        <YesNoField label="Special Colour Patches" value={orderData.special_colour_patches} onChange={(v) => set('special_colour_patches', v)} />
        <div>
          <Label className="text-xs">Coil No.</Label>
          <Input className="mt-1 h-9 text-xs bg-white" value={orderData.coil_no} onChange={(e) => set('coil_no', e.target.value)} placeholder="Enter coil number..." />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-3">
        <div><Label className="text-xs">Photocell Size</Label><Input className="mt-1 h-9 text-xs bg-white" value={orderData.photocell_size} onChange={(e) => set('photocell_size', e.target.value)} placeholder="Enter photocell size..." /></div>
        <div><Label className="text-xs">P.Cell Colour</Label><Input className="mt-1 h-9 text-xs bg-white" value={orderData.photocell_colour} onChange={(e) => set('photocell_colour', e.target.value)} placeholder="Enter photocell colour..." /></div>
        <div>
          <Label className="text-xs">Registration Marks (Image)</Label>
          <Input type="file" accept="image/*" className="mt-1 h-9 text-xs bg-white" onChange={(e) => onFileUpload(e, 'registration_marks_url')} />
          {orderData.registration_marks_url && <p className="text-[10px] text-green-600 mt-0.5">File uploaded</p>}
        </div>
        <div>
          <Label className="text-xs">Reg Marks Inside or Outside</Label>
          <div className="mt-1">
            <Combobox options={[{ value: 'Inside', label: 'Inside' }, { value: 'Outside', label: 'Outside' }]} value={orderData.registration_marks_position} onValueChange={(v) => set('registration_marks_position', v)} placeholder="Select position..." className="h-9 text-xs" />
          </div>
        </div>
      </div>
      <div>
        <Label className="text-xs">Special Instructions (Planning)</Label>
        <Input className="mt-1 h-9 text-xs" value={orderData.planning_special_instructions} onChange={(e) => set('planning_special_instructions', e.target.value)} placeholder="Enter any special instructions..." />
      </div>
    </div>
  );
};

export default PrepressTab;
